import { Link } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import { Info, InfoContainer, LinkStyle } from 'src/styles/footer';

const InfoLinks = () => {
  const { t } = useTranslation();

  return (
    <InfoContainer>
      <Info>
        <Link style={LinkStyle} to={'/privacypolicy'}>
          {t('privacyPolicy.title')}
        </Link>
      </Info>
      <Info>
        <Link style={LinkStyle} to={'/termsofuse'}>
          {t('termsOfUse.title')}
        </Link>
      </Info>
      <Info>
        <Link style={LinkStyle} to={'/accessibility'}>
          {t('accessibility.title')}
        </Link>
      </Info>
    </InfoContainer>
  );
};

export default InfoLinks;
